import { SortDirection, SortFields } from '../../entities/tasks';
import { TaskInList } from '../model/tasks/types';

export const getDividerForSort = (direction: SortDirection, value: string) => {
  if (value.length > 4) {
    return value;
  }

  return direction === SortDirection.Desc ? `${value}-13` : value;
};

export const sortGroupKeyFunc = (direction: SortDirection, withDivider: boolean) => (a: string, b: string) => {
  if (withDivider) {
    return sortStringFunc(direction)(getDividerForSort(direction, a), getDividerForSort(direction, b));
  }

  return sortStringFunc(direction)(a, b);
};

export const sortStringFunc = (direction: SortDirection) => (a: string, b: string) => {
  if (a === b) {
    return 0;
  }

  if (direction === SortDirection.Desc) {
    return a > b ? -1 : 1;
  }

  return a < b ? -1 : 1;
};

export const sortTaskFunc = (field: SortFields, direction: SortDirection) => (a: TaskInList, b: TaskInList) => {
  return sortStringFunc(direction)(a[field], b[field]);
};
